export default {"src":"/pro/_next/static/media/avalanche-logo.67b836ac.svg","height":2501,"width":2501,"blurWidth":0,"blurHeight":0};